import axios from 'axios'
import fn from '../../utils/functions'

function initSession () {
  const session = {
    plannedProcesses: {
      tableData: [],
      totalPlannedProcesses: 0
    },
    queryPlannedProcesses: {
      page: 0,
      size: 50,
      sort: 'group,ASC'
    },
    listSelectedFiltersPlannedProcesses: []
  }
  return session
}
function initLocal () {
  const local = {
    isShowPlannedProcessesGroup: true,
    isShowPlannedProcessesName: true,
    isShowPlannedProcessesDescription: true,
    isShowPlannedProcessesStatus: true,
    isShowPlannedProcessesJobClass: true,
    isShowPlannedProcessesTriggerCron: true
  }
  return local
}
function setByUserLocalPlannedProcesses () {
  const local = {
    isShowPlannedProcessesGroup: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).procesosPlanificados.isShowPlannedProcessesGroup,
    isShowPlannedProcessesName: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).procesosPlanificados.isShowPlannedProcessesName,
    isShowPlannedProcessesDescription: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).procesosPlanificados.isShowPlannedProcessesDescription,
    isShowPlannedProcessesStatus: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).procesosPlanificados.isShowPlannedProcessesStatus,
    isShowPlannedProcessesJobClass: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).procesosPlanificados.isShowPlannedProcessesJobClass,
    isShowPlannedProcessesTriggerCron: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).procesosPlanificados.isShowPlannedProcessesTriggerCron
  }
  return local
}

const state = {
  userConfigLocalStorage: '',
  local: {
    isShowPlannedProcessesGroup: true,
    isShowPlannedProcessesName: true,
    isShowPlannedProcessesDescription: true,
    isShowPlannedProcessesStatus: true,
    isShowPlannedProcessesJobClass: true,
    isShowPlannedProcessesTriggerCron: true
  },
  session: initSession()
}
const getters = {
  plannedProcesses: state => {
    return state.session.plannedProcesses
  },
  queryPlannedProcesses: state => {
    return state.session.queryPlannedProcesses
  },
  listSelectedFiltersPlannedProcesses: state => {
    return state.session.listSelectedFiltersPlannedProcesses
  },
  isShowPlannedProcessesGroup: state => {
    return state.local.isShowPlannedProcessesGroup
  },
  isShowPlannedProcessesName: state => {
    return state.local.isShowPlannedProcessesName
  },
  isShowPlannedProcessesDescription: state => {
    return state.local.isShowPlannedProcessesDescription
  },
  isShowPlannedProcessesStatus: state => {
    return state.local.isShowPlannedProcessesStatus
  },
  isShowPlannedProcessesJobClass: state => {
    return state.local.isShowPlannedProcessesJobClass
  },
  isShowPlannedProcessesTriggerCron: state => {
    return state.local.isShowPlannedProcessesTriggerCron
  }
}

const actions = {

  // Crear key Usuario
  setUserNamePlannedProcesses ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalPlannedProcesses()
    }
  },

  isNewVersionProcesosPlanificadosLocalState ({ state }, localStorage) {
    return fn.isNewVersion(state, localStorage.procesosPlanificados)
  },
  /**
     * Servicio para traer los procesos planificados.
     * Se utiliza también para ordenar la tabla, la paginación,
     * el tamaño de la tabla y los filtros.
     */
  async getPlannedProcesses ({
    commit, rootState
  }, data) {
    try {
      data.query.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        data.query.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/plannedProcesses',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.query
      })

      commit('PLANNED_PROCESSES_STATE', {
        tableData: response.data
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /* Pausa el job */
  async pauseJob ({ commit, rootState }, request) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/plannedProcesses/pause',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          name: request.name,
          group: request.group
        }
      })
      console.log('RESPONSE pauseJob:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /* Reanuda el job */
  async resumeJob ({ commit, rootState }, request) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/plannedProcesses/resume',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          name: request.name,
          group: request.group
        }
      })
      console.log('RESPONSE resumeJob:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /* Interrumpe el job */
  async interruptJob ({ commit, rootState }, request) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/plannedProcesses/interrupt',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          name: request.name,
          group: request.group
        }
      })
      console.log('RESPONSE interruptJob:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /* Pausa todos los jobs */
  async pauseAll ({ commit, rootState }) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/plannedProcesses/pauseAll',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })
      console.log('RESPONSE pauseAll:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /* Reanuda todos los jobs */
  async resumeAll ({ commit, rootState }) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/plannedProcesses/resumeAll',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })
      console.log('RESPONSE resumeAll:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /* shutdown todos los jobs */
  async shutdown ({ commit, rootState }) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/plannedProcesses/shutdown',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })
      console.log('RESPONSE shutdown:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /* standby todos los jobs */
  async standby ({ commit, rootState }) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/plannedProcesses/standby',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })
      console.log('RESPONSE standby:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /* Pausa todos los jobs */
  async start ({ commit, rootState }) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/plannedProcesses/start',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })
      console.log('RESPONSE start:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  plannedProcessesState: ({
    commit
  }, payload) => {
    commit('PLANNED_PROCESSES_STATE', payload)
  },
  queryPlannedProcessesState: ({
    commit
  }, payload) => {
    commit('QUERY_PLANNED_PROCESSES_STATE', payload)
  },
  listSelectedFiltersPlannedProcessesState: ({
    commit
  }, payload) => {
    commit('LIST_SELECTED_FILTERS_PLANNED_PROCESSES_STATE', payload)
  },
  isShowPlannedProcessesGroupAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_PLANNED_PROCESSES_GROUP', payload)
  },
  isShowPlannedProcessesNameAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_PLANNED_PROCESSES_NAME', payload)
  },
  isShowPlannedProcessesDescriptionAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_PLANNED_PROCESSES_DESCRIPTION', payload)
  },
  isShowPlannedProcessesStatusAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_PLANNED_PROCESSES_STATUS', payload)
  },
  isShowPlannedProcessesJobClassAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_PLANNED_PROCESSES_JOB_CLASS', payload)
  },
  isShowPlannedProcessesTriggerCronAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_PLANNED_PROCESSES_TRIGGER_CRON', payload)
  }

}

const mutations = {
  resetSessionPlannedProcesses (state) {
    state.session = initSession()
    state.local = initLocal()
  },
  'PLANNED_PROCESSES_STATE' (state, payload) {
    state.session.plannedProcesses = payload
  },
  'QUERY_PLANNED_PROCESSES_STATE' (state, payload) {
    state.session.queryPlannedProcesses = payload
  },
  'LIST_SELECTED_FILTERS_PLANNED_PROCESSES_STATE' (state, payload) {
    state.session.listSelectedFiltersPlannedProcesses = payload
  },
  'IS_SHOW_PLANNED_PROCESSES_GROUP' (state, payload) {
    state.local.isShowPlannedProcessesGroup = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.procesosPlanificados.isShowPlannedProcessesGroup = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_PLANNED_PROCESSES_NAME' (state, payload) {
    state.local.isShowPlannedProcessesName = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.procesosPlanificados.isShowPlannedProcessesName = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_PLANNED_PROCESSES_DESCRIPTION' (state, payload) {
    state.local.isShowPlannedProcessesDescription = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.procesosPlanificados.isShowPlannedProcessesDescription = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_PLANNED_PROCESSES_STATUS' (state, payload) {
    state.local.isShowPlannedProcessesStatus = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.procesosPlanificados.isShowPlannedProcessesStatus = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_PLANNED_PROCESSES_JOB_CLASS' (state, payload) {
    state.local.isShowPlannedProcessesJobClass = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.procesosPlanificados.isShowPlannedProcessesJobClass = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_PLANNED_PROCESSES_TRIGGER_CRON' (state, payload) {
    state.local.isShowPlannedProcessesTriggerCron = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.procesosPlanificados.isShowPlannedProcessesTriggerCron = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
